import { render } from "./string-dashboard.vue?vue&type=template&id=6feab4a4&ts=true"
import script from "./string-dashboard.vue?vue&type=script&lang=ts"
export * from "./string-dashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__